export enum CandidatesTab {
  All = "All",
  Incomplete = "Incomplete",
  Complete = "Complete",
}
